import logo from './logo.png';
import './App.css';
import PlayerRankings from './components/PlayerRankings';
import GameHistory from './components/GameHistory';
import SeasonWinners from './components/SeasonWinners';
import CountDown from './components/CountDown';
import { useEffect, useState } from "react";

function App() {

  const [players, setPlayers] = useState([]);
  const [games, setGames] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [winnerPlayer, setWinnerPlayer] = useState("");
  const [loserPlayer, setLoserPlayer] = useState("");
  const [newPlayerName, setNewPlayerName] = useState("");

  async function reportMatch(player1, player2, winner) {
    const data = {
      player1_name: player1,
      player2_name: player2,
      winner: winner
    };

    await fetch("https://socpoolapi.dallasagsmith.workers.dev/new/game", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });
  }

  async function addPlayer(name) {
    const data = {
      name: name
    };

    await fetch("https://socpoolapi.dallasagsmith.workers.dev/new/player", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });
  }


  async function handleSubmit(e) {
    const playerMap = {};
      players.forEach(p => {
      playerMap[p.id] = p.name;
    });


    e.preventDefault();

    if (!winnerPlayer || !loserPlayer) return;
    if (winnerPlayer === loserPlayer) return;

    const winnerName = playerMap[winnerPlayer];
    const loserName = playerMap[loserPlayer];

    await reportMatch(winnerName, loserName, winnerName);

    setWinnerPlayer("");
    setLoserPlayer("");
    await loadData();
  }

  async function handleAddPlayer(e) {
    e.preventDefault();

    if (!newPlayerName.trim()) return;

    await addPlayer(newPlayerName.trim());

    setNewPlayerName("");
    await loadData();
  }

  
  async function loadData() {

    const playersRes = await fetch("https://socpoolapi.dallasagsmith.workers.dev/players");
    const playersJson = await playersRes.json();

    const gamesRes = await fetch("https://socpoolapi.dallasagsmith.workers.dev/games");
    const gamesJson = await gamesRes.json();

    const seasonsRes = await fetch("https://socpoolapi.dallasagsmith.workers.dev/seasons");
    const seasonsJson = await seasonsRes.json();

    setPlayers(playersJson);
    setGames(gamesJson);
    setSeasons(seasonsJson);
  }


  useEffect(() => {

    loadData();

  }, []);


  


  return (
    <div className="App">

      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
      </header>

      <h1>Season {seasons.length ? seasons.length : "0"}</h1>
      <CountDown/>

      <h2>Player Rankings</h2>
      <PlayerRankings players={players} games={games} seasons={seasons} />

      <h2 style={{marginTop: "100px"}}>Recent Games</h2>
      <GameHistory games={games} players={players} />

      < SeasonWinners seasons={seasons} style={{marginTop: "100px"}}/>

      <h3 style={{marginTop: "100px"}}>Report Match</h3>

      <form onSubmit={handleSubmit}>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
          Winner: {" "}
          <select
            style={{marginLeft: "10px"}}
            value={winnerPlayer}
            onChange={(e) => setWinnerPlayer(e.target.value)}
          >
            <option value="">Select Player</option>
            {players.map((player) => (
              <option key={player.id} value={player.id}>
                {player.name}
              </option>
            ))}
          </select>
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
          Loser: {" "}
          <select 
            style={{marginLeft: "10px"}}
            value={loserPlayer}
            onChange={(e) => setLoserPlayer(e.target.value)}
          >
            <option value="">Select Player</option>
            {players.map((player) => (
              <option key={player.id} value={player.id}>
                {player.name}
              </option>
            ))}
          </select>
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
          <button type="submit">
            Submit
          </button>
        </div>
      </form>

      <h3 style={{marginTop: "100px"}}>Add New Player</h3>

      <form onSubmit={handleAddPlayer}>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
          <input
            type="text"
            placeholder="Player name"
            value={newPlayerName}
            onChange={(e) => setNewPlayerName(e.target.value)}
          />

          {" "}

          <button type="submit">
            Add Player
          </button>
        </div>

      </form>


    </div>
  );
}

export default App;